(() => {
  const active = new WeakMap();
  const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
  const showText = (result, text) => {
    const p = document.createElement('p');
    p.textContent = text;
    result.append(p);
  };
  const estimate = async root => {
    const button = root.querySelector('[data-hc-shipping-submit]');
    const zip = root.querySelector('[data-hc-shipping-zip]');
    const result = root.querySelector('[data-hc-shipping-result]');
    if (!zip.value.trim()) { zip.focus(); return; }
    active.get(root)?.abort();
    const controller = new AbortController();
    active.set(root, controller);
    const timeout = setTimeout(() => controller.abort(), 20000);
    const params = new URLSearchParams({
      'shipping_address[zip]': zip.value.trim(),
      'shipping_address[country]': root.dataset.country
    });
    const base = root.dataset.cartUrl.replace(/\/$/, '');
    result.replaceChildren();
    showText(result, root.dataset.loading);
    button.disabled = true;
    root.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${base}/prepare_shipping_rates.json?${params}`, {method: 'POST', credentials: 'same-origin', signal: controller.signal});
      if (!response.ok) throw new Error('Shipping destination rejected');
      let data;
      for (let attempt = 0; attempt < 12; attempt++) {
        if (attempt) await wait(900);
        if (!root.isConnected || controller.signal.aborted) return;
        const response = await fetch(`${base}/async_shipping_rates.json?${params}`, {credentials:'same-origin', signal:controller.signal});
        if (!response.ok) throw new Error('Shipping calculation failed');
        data = await response.json();
        if (data && Array.isArray(data.shipping_rates)) break;
      }
      if (!data || !Array.isArray(data.shipping_rates)) throw new Error('Shipping calculation timed out');
      result.replaceChildren();
      if (!data.shipping_rates.length) showText(result, root.dataset.empty);
      else {
        const list = document.createElement('ul');
        const currency = root.dataset.currency || 'SEK';
        data.shipping_rates.forEach(rate => {
          const amount = Number(rate.price);
          if (!Number.isFinite(amount)) return;
          const item = document.createElement('li');
          item.textContent = `${rate.presentment_name || rate.name}: ${new Intl.NumberFormat(document.documentElement.lang || 'sv-SE', {style:'currency',currency}).format(amount)}`;
          list.append(item);
        });
        result.append(list);
      }
      showText(result, root.dataset.note);
    } catch (error) {
      if (root.isConnected) { result.replaceChildren(); showText(result, root.dataset.error); }
    } finally {
      clearTimeout(timeout);
      active.delete(root);
      button.disabled = false;
      root.removeAttribute('aria-busy');
    }
  };
  document.addEventListener('click', event => {
    const estimateButton = event.target.closest('[data-hc-shipping-submit]');
    if (estimateButton) { estimate(estimateButton.closest('[data-hc-shipping-estimate]')); return; }
    const item = event.target.closest('[data-hc-placement]');
    if (!item || !window.Shopify?.analytics?.publish) return;
    if (!window.Shopify.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    try {
      Promise.resolve(window.Shopify.analytics.publish('hatitude:conversion_click', {placement:item.dataset.hcPlacement,product_handle:item.dataset.hcProduct || '',page_type:document.body.classList.contains('template-product')?'product':document.body.classList.contains('template-cart')?'cart':'index'})).catch(() => {});
    } catch {}
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('[data-hc-shipping-zip]')) {
      event.preventDefault();
      estimate(event.target.closest('[data-hc-shipping-estimate]'));
    }
  });
})();
